import { render } from "./FlewidDialog.vue?vue&type=template&id=04ed539a"
import script from "./FlewidDialog.vue?vue&type=script&lang=js"
export * from "./FlewidDialog.vue?vue&type=script&lang=js"

import "./FlewidDialog.vue?vue&type=style&index=0&id=04ed539a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__